<template>
  <div>
    <b-tabs
      pills
      justified
      lazy
    >
      <b-tab>
        <template #title>
          <div>
            <FeatherIcon icon="InfoIcon" />
            Banka Bilgileri
          </div>
        </template>
        <item-form />
        <b-button
          variant="danger"
          :disabled="submitStatus"
          @click="submitForm"
        >
          Kaydet
        </b-button>
      </b-tab>
      <b-tab>
        <template #title>
          <div>
            <FeatherIcon icon="SettingsIcon" />
            Taksit Yapılandırma
          </div>
        </template>
        <installments />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import {
  BButton,
  BTabs, BTab,
} from 'bootstrap-vue'
import ItemForm from '@/views/PosConfigs/Configs/ItemForm.vue'
import Installments from '@/views/PosConfigs/Configs/Installments.vue'

export default {
  name: 'Edit',
  components: {
    BButton,
    BTabs,
    BTab,
    ItemForm,
    Installments,
  },
  data() {
    return {
      submitStatus: false,
    }
  },
  computed: {
    posConfig() {
      return this.$store.getters['posConfigs/getPos_config']
    },
    saveStatus() {
      return this.$store.getters['posConfigs/getPos_configSaveStatus']
    },
  },
  watch: {
    saveStatus(val) {
      if (val.status === true) {
        this.formData = {
          title: null,
        }
        const config = {
          icon: 'success',
          title: 'İşlem Başarılı!',
          text: val.message,
          html: null,
          buttonText: 'Kapat',
        }
        this.sweetAlert(config)
      } else if (val.status === false) {
        const config = {
          icon: 'error',
          title: 'İşlem Hatası!',
          text: val.message,
          html: null,
          buttonText: 'Kapat',
        }
        this.sweetAlert(config)
      }
      this.submitStatus = false
    },
  },
  created() {
    this.getPosConfig()
  },
  methods: {
    sweetAlert(config) {
      this.$swal({
        icon: config.icon,
        title: config.title,
        text: config.text,
        html: config.html,
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        confirmButtonText: config.buttonText,
        buttonsStyling: false,
      })
    },
    getPosConfig() {
      this.$store.dispatch('posConfigs/pos_configView', this.$route.params.id)
    },
    submitForm() {
      this.submitStatus = true
      this.$store.dispatch('posConfigs/pos_configSave', this.posConfig)
    },
  },
}
</script>
